<template>
  <section class="marketing-container">
    <el-tabs
      v-model="activeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :name="String(tab.name)"
      >
        <span slot="label">
          <font-awesome-icon :icon="tab.icon"></font-awesome-icon>
          {{tab.label}}</span>
      </el-tab-pane>
    </el-tabs>
    <template v-if="activeTab==1">
      <div
        v-for="(item,index) in reportList"
        :key="index">
        <p class="title">{{item.title}}</p>
        <div class="flex">
          <v-button
            v-for="(content,index) in item.list"
            :key="'content'+index"
            gray
            @click="handlePath(content.path)"
          >{{content.name}}</v-button>
        </div>
      </div>
    </template>
    <template v-else>
      <marketing-report-list></marketing-report-list>
    </template>
  </section>
</template>

<script>
import Mixinoptions from '@/mixins/options'
import marketingReportList from '../marketing-report-list'

export default {
  name: 'marketing-report',
  components:{
    marketingReportList
  },
  mixins:[Mixinoptions],
  data(){
    return{
      activeTab: '1',
      tabList: [
        {
          name: '1',
          label: 'Report Type',
          icon:'file-contract'
        },
        {
          name: '2',
          label: 'Exported List',
          icon:'arrow-down'
        },
      ],
    }
  },
  computed:{
    isReportList(){
      let {name} = this.$route.query||{}
      return name=='list'
    }
  },
  mounted() {
    this.activeTab = this.isReportList?'2':'1'
  },
  methods:{
    handlePath(path){
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss">
.marketing-container{
  margin-right: 60px;
  .title{
    color: $dark;
    font-family: 'SF Pro Text';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid #D1D5DA;
    width: 100%;
  }
  .flex{
    margin-top: 20px;
    //margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-button{
      width: calc(33.3% - 16px);
      min-height: 40px;;
      margin-bottom: 20px;
      white-space:pre-wrap;
      line-height: 20px;
    }
    .el-button+.el-button {
      margin-left: 0px;
    }
  }
}
</style>
